export class BackendUnreachable extends Error {
    cause;
    constructor(cause) {
        super("Backend unreachable");
        this.cause = cause;
    }
}
export class InvalidFetchAthenaEventsFilters extends Error {
    filters;
    responseBody;
    constructor(filters, responseBody) {
        super("Invalid filters supplied to fetchAthenaEvents");
        this.filters = filters;
        this.responseBody = responseBody;
    }
}
//# sourceMappingURL=errors.js.map